import { html } from "../base/_utilities.js";
import Papa from "papaparse";

export default function eventsListInit() {
    const public_spreadsheet_url = "https://docs.google.com/spreadsheets/d/e/2PACX-1vRaU24NiNnKJJwG0rJO4ghikOYBkEdJ9yB7YAP71sbP7QNUOgTyA4rENPz5wMhumi4E-e2agNiMW0mC/pub?output=csv";

    function init() {
        Papa.parse(public_spreadsheet_url, {
            download: true,
            header: true,
            complete: showInfo,
        });
    }

    window.addEventListener("DOMContentLoaded", init);
    // alert("Successfully processed " + data.length + " rows!")s
    function showInfo(results) {
        const data = results.data;
        for (let i = 0; i < data.length; i++) {
            document.getElementById("events-toggle-list").innerHTML += html`
                <li class="product">
                    <div class="product-details">
                        <h4>${data[i].eventName}</h4>
                        <span class="where  bold">${data[i].eventLocation}</span>
                        <span class="date  pb-2">${data[i].eventDate}</span>
                        <span class="description  pb-2">${data[i].eventDescription}</span>
                        ${data[i].eventLink}
                    </div>
                </li>
            `;
        }
        // console.log(data);
    }
}
